import { render, staticRenderFns } from "./RoleGrid.vue?vue&type=template&id=781e2e3f"
import script from "./RoleGrid.vue?vue&type=script&lang=js"
export * from "./RoleGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports